"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonLoader = exports.ContentLoader = void 0;

var _react = _interopRequireDefault(require("react"));

var _loaderModule = _interopRequireDefault(require("../styles/loader.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ContentLoader = function ContentLoader() {
  return _react.default.createElement("div", {
    className: _loaderModule.default.contentLoaderContainer
  }, _react.default.createElement("div", {
    className: _loaderModule.default.contentLoader
  }));
};

exports.ContentLoader = ContentLoader;

var ButtonLoader = function ButtonLoader(_ref) {
  var size = _ref.size,
      color = _ref.color;
  var customize = {};

  if (size) {
    customize.height = size;
    customize.width = size;
  }

  if (color) {
    customize.borderColor = color;
    customize.borderRightColor = "transparent";
  }

  return _react.default.createElement("div", {
    className: _loaderModule.default.buttonLoader,
    style: customize
  });
};

exports.ButtonLoader = ButtonLoader;